import React, { Component } from 'react';
import Select from 'react-select';
import moment from 'moment';
import axios from 'axios';
import 'moment/locale/pt';

import PdfPainelPSBoxHorizontal from './components/PdfPainelPSBoxHorizontal';
import InsightcareLocalFooter from './components/InsightcareLocalFooter';
import InsightcareHeader from './components/InsightcareHeader';
import ProgressBar from './components/Progress';
import Loading from './components/Loading';

import AuxRoutines from './AuxRoutines';
import { BACKEND_URL } from './config/constants';

//require('moment/locale/pt-BR');

class PainelPSBoxHorizontal extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    this.state = {
      cycle: 0,
      loading: true,
      totalCycles: 0,
      pacientes: [],
      serachPacientes: [],
      filteredPacientes: [],
      numberOfElements: 0,
      base: params.base,
      company: params.company,
      theme: (params.theme === 'dark' ? 'dark' : 'light'),
      iconText: (params.theme === 'dark' ? '_dark' : ''),
      locationName: AuxRoutines.getLocationName(params.base, params.company),
      boolFoward: 1,
      boolPause: 0,
      interval: 0,
      intervalValue: 0,
      value: 0,
    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
    if (this.state.theme === 'dark') {
      document.body.style.backgroundColor = "black";
    }
    this.moveProgress();
    //Carrega o local se existe
    this.loadRequiredData().then(() => {
      this.setState({ appIsReady: true });
    });
  }

  async loadingBar(time) {
    return await new Promise(resolve => {
      this.setState({
        intervalValue: setInterval(async () => {
          resolve('load');
          const newValue = this.state.value + 1;
          if (newValue <= 100 && this.state.boolPause === 0 && this.state.filteredPacientes.length !== 1) {
            this.setState({
              value: newValue,
            });
          }
        }, time),
      });
    });
  }

  moveProgress() {
    clearInterval(this.state.interval);
    clearInterval(this.state.intervalValue);
    if (this.state.boolPause === 0) {
      this.loadingBar(200).then(() => { console.log('loading') });
      this.setState({
        interval: setInterval(async () => {
          this.setState({
            value: 0,
          });
          this.loadRequiredData();
        }, 20000),
      });
    }
  }

  pauseProgress() {
    clearInterval(this.state.intervalValue);
    clearInterval(this.state.interval);
  }


  async loadRequiredData() {
    let sliceSize = 8;

    moment.locale('pt');
    if (this.state.cycle === this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle = 1;
      let totalCycles = Math.ceil(numberOfElements / sliceSize);
      if (totalCycles === 0) {
        cycle = 0;
      }
      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    } else {
      if (this.state.totalCycles > 0) {
        this.setState({ cycle: this.state.cycle + 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * this.state.cycle), sliceSize + (sliceSize * this.state.cycle)) })
      }
    }
  }

  changeCycle(boolFoward) {
    let sliceSize = 8;
    if (boolFoward === 0) {
      if (this.state.cycle === 1) {
        this.setState({ cycle: this.state.totalCycles, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.totalCycles - 1)), sliceSize + (sliceSize * (this.state.totalCycles - 1))) })
      } else {
        this.setState({ cycle: this.state.cycle - 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.cycle - 2)), sliceSize + (sliceSize * (this.state.cycle - 2))) })
      }
    } else if (boolFoward === 1) {
      this.loadRequiredData();
    }
    this.setState({
      value: 0,
    });
  }

	actionPause(boolPause) {
		if (boolPause === 0) {
			this.setState({ boolPause: 1 }, () => {
				this.pauseProgress();
			});
		}
		if (boolPause === 1) {
			this.setState({ boolPause: 0 }, () => {
				this.moveProgress();
			});
		}
	}

  async requestData() {
    let returnData = this.state.pacientes; //In case request fails
    //let response = await axios.get('https://integracao.gruposanta.com.br/command-center/painel-urgencia?base='+this.state.base);
    //let url = 'http://localhost:8080/command-center/painel-urgencia?base='+this.state.base;
    let url = BACKEND_URL + '/command-center/painel-urgencia?base=' + this.state.base;
    if (this.state.company !== undefined && this.state.company !== 'all') {
      url = url + '&company=' + this.state.company;
    }
    let response = await axios.get(url);

    if (response.data && response.data.Status === true) {
      returnData = response.data.ResponseData;
    }

    this.setState({
      serachPacientes: returnData,
      filteredPacientes: this.state.filteredPacientes === 1 ? this.state.filteredPacientes : returnData,
    });

    return returnData;
  }

  textoGrupoPacientes(ciclo, totalCiclos, totalElementos) {
    if (this.state.filteredPacientes.length === 1) {
      return "Mostrando de 1 a 1, de 1 paciente";
    }
    else {
      var de = (ciclo <= 1) ? ciclo : (ciclo - 1) * 8;
      var ate = (ciclo === totalCiclos) ? totalElementos : ciclo * 8;
      return "Mostrando de " + de + " a " + ate + ", de " + totalElementos + " pacientes";
    }
  }

  changeTheme() {
    this.setState({ loading: true });
    this.setState(prevState => ({
      theme: prevState.theme === 'light' ? 'dark' : 'light',
    }));
    var $path = '/painel/ps-horizontal/' + this.state.base + '/' + this.state.company;
    if (this.state.theme === 'light') {
      $path = $path + '/dark';
    }
    window.location.href = $path;
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    const loading = this.state.loading;
    const theme = this.state.theme;
    return (
      <div className={"App " + theme}>
        {
          loading
            ? (<Loading />)
            : (
              <div>
                <InsightcareHeader title="Painel de Acompanhamento" theme={theme} />
                <main className={"content " + theme} id="panel1Styled">
                  <ProgressBar value={this.state.value} max={100} theme={theme}/>
                  <div className={"inforow " + theme}>
                    <div className={'inforow right ' + theme}>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(0)}><img src={"/img/icon_arrow_left" + this.state.iconText + ".svg"} alt=""/></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(1)}><img src={"/img/icon_arrow_right" + this.state.iconText + ".svg"} alt=""/></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.actionPause(this.state.boolPause)}><img src={(this.state.boolPause === 1 ? "/img/icon_play" : "/img/icon_pause") + this.state.iconText + ".svg"} alt=""/></button>
                      <div className='infoText'>{this.textoGrupoPacientes(this.state.cycle, this.state.totalCycles, this.state.numberOfElements)}</div>
                    </div>

                    <div className={'inforow left ' + theme}>
                      <div className='infoText'>Agora são {this.state.currentDateHour}</div>
                      <PdfPainelPSBoxHorizontal title={"Painel de Acompanhamento"} list={(this.state.filteredPacientes.length === 0) ? this.state.serachPacientes : this.state.filteredPacientes} theme={theme} />
                      <form>
                        <div className={'buttonSearch ' + theme}>
                          <img src={"/img/icon_search" + this.state.iconText + ".svg"} alt="" />
                          <Select className={'selectSearch ' + theme}
                            placeholder="Busque por um paciente ou atendimento..."
                            options={
                              this.state.serachPacientes.map(opt => ({
                                key: opt.ATENDIMENTO,
                                label: opt.PACIENTE_NOME + " \n(" + opt.ATENDIMENTO.toLowerCase() + ")",
                                value: opt.PACIENTE_NOME,
                                nome: opt.PACIENTE_NOME,
                                atendimento: opt.ATENDIMENTO,
                              }))}
                            onFocus={opt => {
                              this.actionPause(0);
                            }}
                            onBlur={opt => {
                              this.actionPause(1);
                            }}
                            isClearable={true}
                            onChange={opt => {
                              if (opt !== null && opt !== '') {
                                const pessoa = this.state.serachPacientes.find((elem) => (elem.PACIENTE_NOME === opt.nome || elem.ATENDIMENTO === opt.atendimento));
                                if (pessoa) {
                                  this.setState({
                                    filteredPacientes: [pessoa]
                                  });
                                } else {
                                  this.setState({
                                    filteredPacientes: this.state.serachPacientes,
                                  });
                                }
                              } else {
                                this.setState({
                                  filteredPacientes: this.state.serachPacientes,
                                });
                              }
                            }}
                          />
                        </div>
                      </form>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeTheme()}><img src={"/img/icon_theme" + this.state.iconText + ".svg"} alt=""/></button>
                    </div>
                  </div>

                  <table className={'table table-striped' + (theme === 'dark' ? '-dark' : '')}>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Leito</th>
                        <th>Paciente</th>
                        <th>Laboratório</th>
                        <th>Radiologia</th>
                        <th>Medicação </th>
                        <th>Médico</th>
                      </tr>
                    </thead>
                    <tbody className={theme}>
                      {
                        (this.state.filteredPacientes.length === 1
                          ? this.state.filteredPacientes
                          : this.state.pacientes)
                          .map((data) => {
                            let statusClass = "ready";
                            let statusLab = "-";
                            let statusRx = "-";
                            let statusFarm = "-";
                            let totalLab = parseInt(parseInt(data.LAB_PENDENTE) + parseInt(data.LAB_LAUDADO));
                            let totalRx = parseInt(parseInt(data.RX_PENDENTE) + parseInt(data.RX_LAUDADO));
                            let totalFarm = parseInt(parseInt(data.FARM_PENDENTE) + parseInt(data.FARM_SEPARADO));
                            let tdClassLab = "";
                            let spanClassLab = "";
                            let tdClassRx = "";
                            let spanClassRx = "";
                            let spanClassFarm = "";
                            let name = data.PACIENTE_NOME.split(' ').slice(-1).join(' ') + ', ' + data.PACIENTE_NOME.split(' ')[0].slice(0, 1);
                            let leito = (data.LEITORESUMO) ? data.LEITORESUMO : (data.LEITO) ? data.LEITO : '-';
                            let medico = data.PRESTADOR_NOME.split(' ')[0] + ' ' + data.PRESTADOR_NOME.split(' ').slice(-1).join(' ');
                            let servico = (data.ESPECIALIDADEDESCRICAO) ? ' (' + data.ESPECIALIDADEDESCRICAO + ')' : '';
                            let key = "tr-" + data.ATENDIMENTO + '-' + data.SERVICO;

                            if (data.LAB_LAUDADO > 0) {
                              statusLab = data.LAB_LAUDADO + " de " + totalLab + " disponíveis";
                              tdClassLab = "attention";
                              spanClassLab = "success-circle";
                            } else {
                              if (data.LAB_PENDENTE > 0) {
                                statusLab = "Aguardando " + data.LAB_PENDENTE + " Laudo(s)";
                                tdClassLab = "attention";
                                spanClassLab = "attention-circle";
                              }
                            }

                            if (data.RX_LAUDADO > 0) {
                              statusRx = data.RX_LAUDADO + " de " + totalRx + " disponíveis";
                              tdClassRx = "attention";
                              spanClassRx = "success-circle";
                            } else {
                              if (data.RX_PENDENTE > 0) {
                                statusRx = "Aguardando " + data.RX_PENDENTE + " Laudo(s)";
                                tdClassRx = "attention";
                                spanClassRx = "attention-circle";
                              }
                            }

                            if (data.FARM_SEPARADO > 0) {
                              statusFarm = data.FARM_SEPARADO + " de " + totalFarm + " dispensados";
                              spanClassFarm = "success-circle";
                            } else {
                              if (data.FARM_PENDENTE > 0) {
                                statusFarm = "Aguardando " + data.FARM_PENDENTE + " itens";
                                spanClassFarm = "attention-circle";
                              }
                            }

                            let time = data.DURACAO_ATENDIMENTO;

                            if (data.DURACAO_ATENDIMENTO > 60) {
                              var hours = (data.DURACAO_ATENDIMENTO / 60);
                              var rhours = Math.floor(hours);
                              var minutes = (hours - rhours) * 60;
                              var rminutes = Math.round(minutes);
                              time = rhours + " hs " + rminutes + " mins";
                            } else {
                              time = time + ' mins';
                            }

                            return (
                              <tr key={key} className={statusClass}>
                                <td><div className="alert-label"></div></td>
                                <td>{leito}<br></br>{time}</td>
                                <td><b>{name}</b></td>
                                <td className={tdClassLab}><span className={spanClassLab}></span>{statusLab}</td>
                                <td className={tdClassRx}><span className={spanClassRx}></span>{statusRx}</td>
                                <td className={tdClassRx}><span className={spanClassFarm}></span>{statusFarm}</td>
                                <td><b>{medico + servico}</b></td>
                              </tr>
                            )
                          })
                      }
                    </tbody>
                  </table>
                </main>
                <InsightcareLocalFooter hospitalName={this.state.locationName} theme={theme} />
              </div>
            )
        }
      </div>
    );
  }

}

export default PainelPSBoxHorizontal;
